<template>
  <space> <slot></slot> </space>
</template>

<script>
import Space from "../Workspace/DrawingSpace";

export default {
  name: "PageFormatHandler",
  components: {
    Space
  },
  props: {
    format: {},
    orientation: {
      type: String,
      default: "portrait"
    }
  },
  methods: {
    hackPageSize() {
      this.undoHackPageSize();
      const s = document.createElement("style");
      s.id = "pageSizeHack";
      s.innerHTML = `@media print { @page { size: ${
        this.format === "A4" ? `A4 ${this.orientation}` : "A3 landscape"
      }; }
      html { -webkit-print-color-adjust: exact; }
      }`;
      document.body.appendChild(s);
    },
    undoHackPageSize() {
      const h = document.querySelector("#pageSizeHack");
      if (h) document.body.removeChild(h);
    }
  },
  watch: {
    format() {
      this.hackPageSize();
    }
  },
  mounted() {
    this.hackPageSize();
  },
  beforeDestroy() {
    this.undoHackPageSize();
  }
};
</script>
